import { Link } from '@egw/components'
import { CoreExternalRoutes, type FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { Trans, useTranslation } from '@egw/i18n'
import { useMemo, type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { WealthDisclosuresV3 } from './wealth-disclosures-v3'

export const WealthDisclosures: FC<{ showCheckingDisclosure?: boolean; className?: string }> = ({
  showCheckingDisclosure,
  className,
}) => {
  const { t } = useTranslation('features-system')

  const baseClassName = 'w-full flex flex-col gap-sm'

  const finalClassName = twMerge(baseClassName, className)

  const { flags } = useFlags<FeatureFlags>()

  const translationKey = useMemo(() => {
    switch (flags.rolloutEgwDisclosures) {
      case 'apex_migration_12-2025':
        return 'wealth_disclosures_yeet_coastal'
      case 'release_09-09-2025':
        return 'wealth_disclosures_9-9-25'
      default:
        return 'wealth_disclosures'
    }
  }, [flags])

  // V3 disclosures for Yeet Coastal
  if (translationKey === 'wealth_disclosures_yeet_coastal') {
    return <WealthDisclosuresV3 className={finalClassName} />
  }

  // V2 disclosures for other cases
  return (
    <div data-testid="evergreen-disclosure" className={finalClassName}>
      <p className="typo-primary-sm-light text-text-meta">{t(`${translationKey}.p_1`)}</p>
      <p className="typo-primary-sm-semibold text-text-meta">{t(`${translationKey}.p_2`)}</p>
      {showCheckingDisclosure ? (
        <p className="typo-primary-sm-light text-text-meta">{t(`${translationKey}.p_3`)}</p>
      ) : null}
      <p className="typo-primary-sm-light text-text-meta">
        <Trans t={t} i18nKey={`${translationKey}.p_4`}>
          <Link
            href={CoreExternalRoutes.adv2ABAndCRS_EGW}
            className="cursor-pointer hover:underline inline-flex typo-primary-sm-semibold text-text-action"
          />
        </Trans>
      </p>
      <p className="typo-primary-sm-light text-text-meta">
        <Trans t={t} i18nKey={`${translationKey}.p_5`}>
          <Link
            href={CoreExternalRoutes.finraBrokerCheck_baseUrl}
            className="cursor-pointer hover:underline inline-flex typo-primary-sm-semibold text-text-action"
          />
        </Trans>
      </p>
      <p className="typo-primary-sm-light text-text-meta">{t(`${translationKey}.p_6`)}</p>
      <p className="typo-primary-sm-light text-text-meta">{t(`${translationKey}.p_7`)}</p>
      <p className="typo-primary-sm-light text-text-meta">{t(`${translationKey}.p_8`)}</p>
    </div>
  )
}
